import { render, staticRenderFns } from "./CompetitionListInterestLayout.vue?vue&type=template&id=42fa4673&scoped=true&"
import script from "./CompetitionListInterestLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionListInterestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa4673",
  null
  
)

export default component.exports